import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-code",
  "use": "icon-code-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 200 200\" id=\"icon-code\"><defs><style>#icon-code .cls-1{fill:#b2b2b2;}</style></defs><path class=\"cls-1\" d=\"M123.44,37.51A39.06,39.06,0,0,0,84.38,76.56,40.25,40.25,0,0,0,85,83.73L37.51,131.24v23.44a7.81,7.81,0,0,0,7.81,7.81h7.81v-7.81H68.76V139.06H84.38V123.43H100l10.14-10.14a38.42,38.42,0,0,0,13.3,2.34,39.06,39.06,0,0,0,0-78.12Zm11.69,39.07a11.72,11.72,0,1,1,11.72-11.71,11.71,11.71,0,0,1-11.72,11.71Zm0,0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol